import React from "react";
import {
    Box,
    Typography,
    Paper,
    Container,
    Alert,
    Divider
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

const Disclaimer = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <WarningIcon sx={{ mr: 2, color: 'warning.main', fontSize: 32 }} />
                    <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                        Disclaimer
                    </Typography>
                </Box>

                <Divider sx={{ mb: 3 }} />

                <Typography variant="body1" paragraph sx={{ lineHeight: 1.7, color: 'text.primary' }}>
                    The information provided by FlokiTools is for general informational purposes only. All information on the site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness of any information on the site.
                </Typography>

                <Alert severity="warning" sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Data Accuracy Notice
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                        The data we provide may not be 100% accurate. Indexing blockchain data and attempting to link user IDs to transactions is a complex process that involves parsing large amounts of data from multiple sources. Due to the inherent complexity of blockchain analysis, network delays, and the evolving nature of blockchain technology, there may be discrepancies, delays, or inaccuracies in the information displayed. Users should verify critical information independently and should not rely solely on our data for important decisions.
                    </Typography>
                </Alert>

                <Typography variant="body1" sx={{ lineHeight: 1.7, color: 'text.primary' }}>
                    Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.
                </Typography>
            </Paper>
        </Container>
    );
};

export default Disclaimer;